import { MachineFixing } from "../interfaces/api/MachineFixing";
import { Rototilt } from "../interfaces/api/Rototilt";
import { ProductCategory } from "../shared/enums/ProductCategory";
import { filterHelper } from "../shared/helpers/filterHelper";
import { filtering } from "../shared/helpers/productFilterHelper";
import { useMachineTonnage } from "../store/hooks/useMachineTonnage";
import { useMarket } from "../store/hooks/useMarket";
import { useWizard } from "../store/hooks/useWizard";
import { ProductData } from "../store/interfaces/productData";

interface FilterMachineFixingsProps {
  machineFixingsData: ProductData;
  selectedProductCategory: ProductCategory;
  selectedTiltrotator: Rototilt;
}

interface FilterMachineFixingsOutput {
  filteredMachineFixings: MachineFixing[];
}

export const useFilterMachineFixings = ({
  machineFixingsData,
  selectedProductCategory,
  selectedTiltrotator,
}: FilterMachineFixingsProps): FilterMachineFixingsOutput => {
  const market = useMarket();
  const machineTonnage = useMachineTonnage();
  const wizardStep = useWizard();

  if (!machineFixingsData || !machineTonnage) {
    return {
      filteredMachineFixings: [],
    };
  }

  const unfilteredMachineFixnings = machineFixingsData.data as MachineFixing[];
  const filteredMachineFixnings = unfilteredMachineFixnings
    .filter((item) => filtering.market(item, market))
    .filter((machineFixing) =>
      filterHelper.machineFixings({
        machineFixing,
        machineTonnage,
        market,
        productCategory: selectedProductCategory,
        tiltrotator: selectedTiltrotator,
        activeWizardStep: wizardStep.activeStepIndex
      })
    );

  return {
    filteredMachineFixings:
      filteredMachineFixnings || unfilteredMachineFixnings,
  };
};
